export default "__VITE_ASSET__62cb3c4b__"